export default "__VITE_ASSET__DZo1G$HB__"